import React, { Component } from "react";
import { FieldArray } from "redux-form";
import { Row, Col } from "react-bootstrap";
import styles from "./AddFilterBox.scss";
import FilterBox from "./FilterBox";
import removeFilterIcon from "../../../../../assets/images/remove-filter-icon.svg";
import addFilterIcon from "../../../../../assets/images/add-filter-icon.svg";

class AddFilterBox extends Component {
  renderBox = ({ fields, meta: { touched, error } }) => {
    return (
      <div>
        {fields.map((box, index) => (
          <Row key={index}>
            <Col xs={11} md={11}>
              <FilterBox
                name={`${box}.id`}
                inputName={`${box}`}
                selected={fields.get(index).id}
                index={index}
                skillsCategoriesOptions={this.props.skillsCategoriesOptions}
                skillsOptions={this.props.skillsOptions}
                selectedSkillCategory={this.props.selectedSkillCategory}
                commuteCitiesOptions={this.props.commuteCitiesOptions}
                levelsOptions={this.props.levelsOptions}
                industriesOptions={this.props.industriesOptions}
              />
            </Col>
            <Col xs={1} md={1}>
              <img
                src={removeFilterIcon}
                onClick={() => fields.remove(index)}
                className={styles.icon}
              />
            </Col>
          </Row>
        ))}

        <div
          onClick={() => fields.push({})}
          className={styles.addFilterContainer}
        >
          <img src={addFilterIcon} className={styles.addIcon} />
          <div className={styles.addText}>{this.props.addText}</div>
        </div>
        {touched && error && <span>{error}</span>}
      </div>
    );
  };

  render() {
    return <FieldArray name={this.props.name} component={this.renderBox} />;
  }
}

export default AddFilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/project/matches/components/AddFilterBox.js